import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Partnership } from '../types/types';

interface SupportState {
  support_or_partnership: Partnership[];
}

const initialState: SupportState = {
  support_or_partnership: [],
};

const supportsSlice = createSlice({
  name: 'support',
  initialState,
  reducers: {
    setSupports(state, action: PayloadAction<Partnership[]>) {
      state.support_or_partnership = action.payload;
    },

    addSupport(state, action: PayloadAction<Partnership>) {
      state.support_or_partnership.push(action.payload);
    },

    removeSupport(state, action: PayloadAction<Partnership>) {
      state.support_or_partnership = state.support_or_partnership.filter(
        (support) => support.name !== action.payload.name,
      );
    },

    clearSupports(state) {
      state.support_or_partnership = [];
    },
  },
});

export const { setSupports, addSupport, removeSupport, clearSupports } =
  supportsSlice.actions;
export default supportsSlice.reducer;
